import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'tog-loader-button',
  templateUrl: './loader-button.component.html',
  styleUrls: ['./loader-button.component.scss']
})
export class LoaderButton implements OnInit {
  defaultStates: any[] = [
    { inactive: 'Go',            clicked: 'Please wait...',confirmed: 'Done' }, // this is the invalid state and should always be at position 0
    { inactive: 'Log in',        clicked: 'Logging in',    confirmed: 'You\'re in' },
    { inactive: 'Log out',       clicked: 'Logging out',   confirmed: 'Logged out' },
    { inactive: 'Add',           clicked: 'Adding',        confirmed: 'Added' },
    { inactive: 'Archive',       clicked: 'Archiving',     confirmed: 'Archived' },
    { inactive: 'Cancel',        clicked: 'Cancelling',    confirmed: 'Cancelled' },
    { inactive: 'Yes',           clicked: 'Yes',           confirmed: 'Yes' },
    { inactive: 'Create',        clicked: 'Creating',      confirmed: 'Created' },
    { inactive: 'Delete',        clicked: 'Deleting',      confirmed: 'Deleted' },
    { inactive: 'Download',      clicked: 'Downloading',   confirmed: 'Downloaded' },
    { inactive: 'Enroll',        clicked: 'Enrolling',     confirmed: 'Enrolled' },
    { inactive: 'Lock',          clicked: 'Locking',       confirmed: 'Locked' },
    { inactive: 'Publish',       clicked: 'Publishing',    confirmed: 'Published' },
    { inactive: 'Restore',       clicked: 'Restoring',     confirmed: 'Restored' },
    { inactive: 'Save',          clicked: 'Saving',        confirmed: 'Saved' },
    { inactive: 'Send',          clicked: 'Sending',       confirmed: 'Sent' },
    { inactive: 'Submit',        clicked: 'Submitting',    confirmed: 'Submitted' },
    { inactive: 'Unarchive',     clicked: 'Unarchiving',   confirmed: 'Unarchived' },
    { inactive: 'Unlock',        clicked: 'Unlocking',     confirmed: 'Unlocked' },
    { inactive: 'Upload',        clicked: 'Uploading',     confirmed: 'Uploaded' },
    { inactive: 'Update',        clicked: 'Updating',      confirmed: 'Updated' }
  ];

  buttonText: string = '';
  buttonStates: any = this.defaultStates[0];
  currentState: string = 'inactive';
  canShowConfirm: boolean = false;
  attemptedToConfirm: boolean = false;

  @Input() delayTime: number = 600;
  @Input() preventModalClose: boolean = false;

  @Input() btnType: string = 'button';
  @Input() disableWhen: boolean = false;

  // select from standard Togglit button colors (default white)
  @Input() btnTogglitRed: boolean = false;
  @Input() btnTogglitPurple: boolean = false;
  @Input() btnTogglitDarkPurple: boolean = false;
  @Input() btnTogglit: boolean = false;
  @Input() btnDefault: boolean = false;

  // for stictly setting button sizes
  // do not set for a variable-width button
  @Input() smallBtn: boolean = false;
  @Input() largeBtn: boolean = false;

  // accepts a single string to select one of the default state options
  // should match the inactive state of the option you want (not case-sensitive)
  @Input() set text(stringType: string) {
    for (let i = 0; i < this.defaultStates.length; i++) {
      if (this.defaultStates[i].inactive.toLowerCase() == stringType.toLowerCase()) {
        this.buttonStates = this.defaultStates[i];
        return;
      }
    }
    this.buttonStates = this.defaultStates[0]; // if no states match, set the invalid state
    console.log('Invalid state input on loader button: ' + stringType);
  }

  // If we need a set of button states that aren't in defaultStates, provide them
  // Should be an array of strings in the proper order: inactive, clicked, then confirmed
  @Input() set customText(textOptions: string[]) {

    // check that we have three strings in the array
    if (textOptions.length === 3) {
      this.buttonStates.inactive = textOptions[0];
      this.buttonStates.clicked = textOptions[1];
      this.buttonStates.confirmed = textOptions[2];
    } else {
      this.buttonStates = this.defaultStates[0]; // if it's not valid, set up our invalid state so we know something's wrong
      console.log('Invalid state input on loader button:');
      console.log(textOptions);
    }
  }

  @Output('active') active = new EventEmitter();

  @ViewChild('dismissModals') dismissModals: ElementRef;

  constructor() { }

  ngOnInit() {
    // defaults the button style if no input passed in
    if (!this.btnTogglitRed && !this.btnTogglit && !this.btnTogglitPurple && !this.btnTogglitDarkPurple && !this.btnDefault) {
      this.btnDefault = true;
    }
  }

  getCurrentButtonText() {
    return this.buttonStates[this.currentState];
  }

  emitClick(e: any) {
    e.preventDefault();
    this.setClicked();
    this.active.emit();
  }

  setInactive() {
    this.currentState = 'inactive';
  }

  setClicked() {
    this.currentState = 'clicked';
    this.attemptedToConfirm = false;
    this.canShowConfirm = false;

    setTimeout(() => {
      this.canShowConfirm = true;
      if (this.attemptedToConfirm) this.setConfirmed();
    }, this.delayTime);
  }

  setConfirmed() {
    if (this.canShowConfirm) {
      this.currentState = 'confirmed';

      // resets button after one second
      setTimeout(() => {
       if (!this.preventModalClose) { this.dismissModals.nativeElement.click(); }
        this.setInactive();
      }, 1000);
    } else {
      this.attemptedToConfirm = true;
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/loader-button/loader-button.component.ts